import React, { useMemo, useState } from "react";
import { Box, AppBar, Toolbar, Button, ButtonGroup } from "@mui/material";
import {
  MapOutlined,
  WarningAmberOutlined,
  DirectionsBusOutlined,
} from "@mui/icons-material";
import MapOverview from "./MapOverview"; // Your existing component
import AlarmHistory from "./AlarmHistory";
import ST9100 from "./ST9100";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const HomeView = () => {
  const navigate = useNavigate(); // ✅ Fixed: Hook must be called inside component
  const location = useLocation(); // ✅ Added to track current route

  // Determine active view from URL path
  const activeView = useMemo(() => {
    const path = location.pathname;
    if (path.includes("/map-overview")) return "map-overview";
    if (path.includes("/alarm-history")) return "alarm-history";
    if (path.includes("/fleet")) return "fleet";
    return "map-overview"; // Default
  }, [location.pathname]);

  const navigationItems = [
    {
      id: "map-overview",
      label: "Map Overview",
      icon: <MapOutlined />,
      component: MapOverview,
      color: "#1565c0",
      path: "../home-view/map-overview",
    },
    {
      id: "alarm-history",
      label: "Alarm History",
      icon: <WarningAmberOutlined />,
      component: AlarmHistory,
      color: "#1565c0",
      path: "../home-view/alarm-history",
    },
    {
      id: "fleet",
      label: "ST9100 Fleet",
      icon: <DirectionsBusOutlined />,
      component: ST9100,
      color: "#1565c0",
      path: "../home-view/fleet",
    },
  ];

  const activeItem = navigationItems.find((item) => item.id === activeView);
  const ActiveComponent = activeItem?.component || MapOverview;

  const handleViewChange = (item) => {
    navigate(item.path);
  };

  return (
    <Box sx={{ bgcolor: "#1e293b", minHeight: "86vh" }}>
      {/* Navigation Bar */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "#111827", boxShadow: 1 }}
      >
        <Toolbar sx={{ justifyContent: "right", py: 1 }}>
          <ButtonGroup
            variant="contained"
            sx={{
              boxShadow: 3,
              "& .MuiButton-root": {
                borderRadius: 0,
                boxShadow: "none",
                outline: "none",
                // ✅ Force border on all buttons including the last one
                "&:not(:last-of-type)": {
                  borderRight: `1px solid #4b5563 !important`,
                },
              },
            }}
          >
            {navigationItems.map((item) => (
              <Button
                key={item.id}
                startIcon={item.icon}
                onClick={() => handleViewChange(item)}
                sx={{
                  px: 2.9,
                  fontWeight: {
                    xs: 400, // Small screen
                    sm: 500, // Medium screen
                    md: 600, // Large screen
                  },
                  textTransform: "none",
                  fontSize: {
                    xs: "9px", // Small screen
                    sm: "13px", // Medium screen
                    md: "14px", // Large screen
                  },
                  minWidth: "160px",
                  bgcolor: activeView === item.id ? item.color : "#374151",
                  color: "white",
                  border: `1px solid #4b5563 !important`, // ✅ Add !important to override ButtonGroup
                  "&:hover": {
                    bgcolor: activeView === item.id ? item.color : "#4b5563",
                    borderColor:
                      activeView === item.id ? item.color : "#6b7280",
                  },
                  transition: "all 0.2s ease-in-out",
                }}
              >
                {item.label}
              </Button>
            ))}
          </ButtonGroup>
        </Toolbar>
      </AppBar>

      {/* Content Area */}
      <Box sx={{ position: "relative", minHeight: "86vh" }}>
        <ActiveComponent />
      </Box>
    </Box>
  );
};

export default HomeView;
